<div class="brand-loading-mask" role="status" aria-live="polite" aria-label="系統載入中">
  <div
    class="brand-loading-content"
    [class.is-separated]="separateForDialog"
    [class.separation-cardinal]="separationDirection === 'cardinal'"
    [class.separation-horizontal]="separationDirection === 'horizontal'"
    [class.separation-perimeter]="separationDirection === 'perimeter'">
    <div class="brand-loading-pinwheel-shell">
      <img
        class="brand-loading-pinwheel"
        #pinwheel
        src="assets/images/asiavision-loading-pinwheel.png"
        alt=""
        aria-hidden="true"
        (animationstart)="onPinwheelCycleStart($event)"
        (animationiteration)="onPinwheelCycle($event)">
    </div>

    <div class="brand-loading-copy-shell">
      <div class="brand-loading-title-shell">
        <div class="brand-loading-title brand-loading-shine">展望亞洲科技</div>
      </div>
      <div class="brand-loading-subtitle-shell">
        <div class="brand-loading-subtitle brand-loading-shine">醫療整合性服務<span class="brand-loading-dot">・</span>第一品牌</div>
      </div>
    </div>
  </div>

  <div
    *ngFor="let flyingPinwheel of flyingPinwheels; trackBy: trackFlyingPinwheel"
    class="flying-pinwheel-path"
    [attr.data-flying-pinwheel-id]="flyingPinwheel.id"
    [style.top.px]="flyingPinwheel.startY"
    [style.left.px]="flyingPinwheel.startX"
    [style.width.px]="flyingPinwheel.size"
    [style.height.px]="flyingPinwheel.size"
    aria-hidden="true">
    <img
      class="flying-pinwheel"
      src="assets/images/asiavision-loading-pinwheel.png"
      alt="">
  </div>

  <div class="brand-loading-status">
    <span class="brand-loading-status-indicator" aria-hidden="true"></span>
    <span>正在登入系統</span>
    <span class="brand-loading-status-dots" aria-hidden="true">
      <span></span><span></span><span></span>
    </span>
  </div>
</div>
